export default function clearValidateRepair(this) {
  this.$root.$on('clearValidateRepair', (obj_error) => {
    this.error_repair_form = obj_error;
  });
}
